@use '../../../../design-tokens/typography/typography' as *;

@layer design-system {
  .medianText {
    @include typography-v2-body-base;
    font-family: var(--font-roboto-mono);
    text-anchor: end;
  }

  .medianTextPositive {
    fill: var(--viz-bullish);
  }

  .medianTextNegative {
    fill: var(--viz-bearish);
  }

  .medianTextNeutral {
    fill: var(--text-default);
  }

  .labelText {
    @include typography-v2-body-base;
    fill: var(--text-default);
  }
}
